import { makeStyles } from '@material-ui/core/styles';
import ContainerBackgroundPathImage from '@assets/new-overview-initial-path.svg'
import ContainerBackgroundBikeImage from '@assets/new-overview-initial-bike-icon.svg'
import ContainerBackgroundHomeImage from '@assets/new-overview-initial-home-icon.svg'
const useStyles = makeStyles(({breakpoints, variables}) => ({
  parallaxContainer:{
    transform: 'translate3d(0,0,0)',
    overflow:'hidden',
    width: '1280px',
    height: '620px',
    position: 'absolute',
    top: '0px',
    [breakpoints.between('sm','md')]: {
        width:'100%', 
    },
  },
  animatedBG: {
    backgroundSize: '1280px 620px',
    backgroundPosition:'0px 0px',
    width:'1280px',
    height:'620px',
    top:'0px',
    [breakpoints.down('sm')]: {
      marginLeft:'-300px',
      height:'615px',
  },
    position:'absolute',
    '& .animated-marker-image-container':{
      width:'695px',
      height: '135px',
      position:'absolute',
      top: '60px',
      left:'370px',
      zIndex:1,
      background:`url(${ContainerBackgroundBikeImage}) no-repeat, url(${ContainerBackgroundHomeImage}) no-repeat`,
      backgroundPosition:'20px 97px, 97% 0px',
    },  
    '& .path-image-container':{
      width:'621px',
      height:'115px',
      background:`url(${ContainerBackgroundPathImage}) no-repeat`,
      backgroundPosition:'right',
      position:'absolute',
      top: '66px',
      right:'100%',
      transform: 'translateX(1030px)',
      backgroundOrigin:'content-box',
      paddingLeft:'15px'
    }
  },
}));

export default useStyles;
